import React, { useContext, useState } from 'react';
import TextField from '@material-ui/core/TextField';
import { Redirect } from 'react-router';
import IntlMessages from '../../../utils/IntlMessages';
import Grid from '@material-ui/core/Grid';
import GridContainer from '../../../../@jumbo/components/GridContainer';

import { useDispatch } from 'react-redux';
import Button from '@material-ui/core/Button';
import { Box, fade } from '@material-ui/core';
import { AuhMethods } from '../../../../services/auth';
import ContentLoader from '../../ContentLoader';
import makeStyles from '@material-ui/core/styles/makeStyles';
import CmtImage from '../../../../@coremat/CmtImage';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { CurrentAuthMethod } from '../../../constants/AppConstants';
import { NavLink } from 'react-router-dom';
import AuthWrapper from './AuthWrapper';
import { THEME_TYPES } from '../../../constants/ThemeOptions';
import AppContext from '../../contextProvider/AppContextProvider/AppContext';
import axios from 'axios';
import MuiAlert from '@material-ui/lab/Alert';

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles(theme => ({
  authThumb: {
    backgroundColor: fade(theme.palette.primary.main, 0.12),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 20,
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '50%',
      order: 2,
    },
  },
  authContent: {
    padding: 30,
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: props => (props.variant === 'default' ? '50%' : '100%'),
      order: 1,
    },
    [theme.breakpoints.up('xl')]: {
      padding: 50,
    },
  },
  titleRoot: {
    marginBottom: 14,
    color: theme.palette.text.primary,
  },
  textFieldRoot: {
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: fade(theme.palette.common.dark, 0.12),
    },
  },
  formcontrolLabelRoot: {
    '& .MuiFormControlLabel-label': {
      [theme.breakpoints.down('xs')]: {
        fontSize: 12,
      },
    },
  },
}));
//variant = 'default', 'standard'
const PasswordChangeForm = ({ method = CurrentAuthMethod, variant = 'default', wrapperVariant = 'default' }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [passwordChanged, setPasswordChanged] = useState(-1);
  const [password2, setPassword2] = useState('');
  const [hotelCode, setHotelCode] = useState('');
  const [demoCode, setDemoCode] = useState('DEMO');
  const [demoEmail, setDemoEmail] = useState('DEMO');
  const [demoPassword, setDemoPassword] = useState('DEMO');
  const dispatch = useDispatch();
  const classes = useStyles({ variant });

  const date = new Date();
  if (variant == 'milenij') {
    //   setThemeType(THEME_TYPES.DARK);
  }

  const onSubmit = () => {
    if (variant === 'standard' && password2 != '' && password != '' && password == password2) {
      /*var x = 1;
      if (x == 1) localStorage.setItem('expiredPassword', false);
      setPasswordChanged(x);
      return;*/
      const token = localStorage.getItem('token');
      var action = 'changeUserSetting';
      const senddata = {
        Action: action,
        token: token,
        Data: {
          newPassword: password,
        },
      };
      var pmsUrl = 'https://secure.webbookingpro.com/api/pms.php';

      axios.post(pmsUrl, senddata).then(res => {
        if (res.data != null && res.data.newToken != null && res.data.newToken != '') {
          localStorage.setItem('token', res.data.newToken);
        }
        let x = 0;
        if (res.data != null) {
          if (res.data.result == true) x = 1;
        }
        if (x == 1) localStorage.setItem('expiredPassword', false);
        setPasswordChanged(x);
      });
    }
  };

  const onSubmit2 = () => {
    if (variant === 'milenij') dispatch(AuhMethods[method].onLogin({ demoEmail, demoPassword, demoCode }));
  };

  return (
    <AuthWrapper variant={wrapperVariant}>
      {passwordChanged == 1 && <Redirect to="/" />}
      {variant === 'default' ? (
        <Box className={classes.authThumb}>
          <CmtImage src={'/images/auth/login-img.png'} />
        </Box>
      ) : null}
      <Box className={classes.authContent}>
        <Box mb={7}>
          <GridContainer>
            <Grid
              container
              xs={12}
              sm={12}
              xl={12}
              direction="row"
              alignContent="center"
              alignItems="center"
              justify="center">
              <img
                src={variant === 'standard' ? '/images/logo-wbp.png' : '/images/logo-milenij.png'}
                style={{ maxHeight: '96px' }}
              />
            </Grid>
          </GridContainer>
        </Box>
        {passwordChanged == 1 && (
          <Alert severity="success">
            <IntlMessages id="profile.passwordSuccess" />
          </Alert>
        )}
        {passwordChanged == 0 && (
          <Alert severity="error">
            <IntlMessages id="profile.passwordFail" />
          </Alert>
        )}
        <Typography component="div" variant="h1" className={classes.titleRoot}>
          {variant === 'standard' ? <IntlMessages id="profile.passwordChange" /> : 'Milenij Hotel Mobile'}
        </Typography>
        <Typography component="div" variant="p" className={classes.rootText}>
          <IntlMessages id="profile.passwordChangeInto" />
          <br />
        </Typography>

        <form>
          <Box mb={2}>
            <TextField
              type="password"
              label={variant === 'standard' ? <IntlMessages id="profile.newPassword" /> : 'Lozinka'}
              fullWidth
              onChange={event => setPassword(event.target.value)}
              defaultValue={password}
              margin="normal"
              variant="outlined"
              className={classes.textFieldRoot}
            />
          </Box>
          <Box mb={2}>
            <TextField
              type="password"
              label={variant === 'standard' ? <IntlMessages id="profile.repeatNewPassword" /> : 'Lozinka'}
              fullWidth
              onChange={event => setPassword2(event.target.value)}
              defaultValue={password2}
              margin="normal"
              variant="outlined"
              className={classes.textFieldRoot}
            />
          </Box>

          <Box display="flex" alignItems="center" justifyContent="space-between" mb={5}>
            {variant === 'standard' && (
              <Button onClick={onSubmit} variant="contained" color="primary">
                <IntlMessages id="profile.doChange" />
              </Button>
            )}
          </Box>
        </form>

        {dispatch(AuhMethods[method].getSocialMediaIcons())}
        {variant === 'standard' ? (
          <small>Copyright© {date.getFullYear()} Alpha Software Ltd.</small>
        ) : (
          <small>Powered by WebBookingPro</small>
        )}
        <ContentLoader />
      </Box>
    </AuthWrapper>
  );
};

export default PasswordChangeForm;
